/**
 * @module core/aem
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 * Common Component. Its used in product-offering(PDP) and product Selector page
 */
/** */
/* tslint:disable: no-loop-func max-file-line-count*/
/*tslint:disable:max-file-line-count */
// Core
import { Component, Input, OnInit } from '@angular/core';
// Interfaces
import { ProductDetails } from 'app/experience/shop/product-details/interfaces/product-details.interface';
import { ItemDetail, DeviceSimInfo } from 'app/support/api/common/product.interface';
import { ConfigData } from 'app/experience/repdash/interfaces/aem-content.interface';
// Environment settings
import { SETTINGS } from '@environment/settings';
// Services
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { CommonUtilService } from '@support/shared/services/common-util.service';
import { ProductDetailsService } from '@experience/shop/services/product-details.service';

@Component({
  selector: 'tmo-device-selection-details',
  templateUrl: './device-selection-details.component.html',
})
export class DeviceSelectionDetailsComponent implements OnInit {
  /**
   * Stores selected device details
   */
  @Input() public deviceDetails: ProductDetails;

  /**
   * Stores selected specific details. Ex: color, URL etc..,
   */
  @Input() public set selectedItem(device: ItemDetail) {
    if (device) {
      this.selectedDevice = device;
      this.productDetailsService.getselectedDeviceId$.emit(this.selectedDevice);
      this.mainImageUrl = this.objectService.get(this.selectedDevice, 'mainImageUrl')
        ? this.extTmoImagesUrl.concat(this.objectService.get(this.selectedDevice, 'mainImageUrl'))
        : this.dummyImage;
      if (Array.isArray(device.deviceSimInfo)) {
        this.deviceSimInfo = device.deviceSimInfo;
      }
    }
  }

  /**
   * Holds selected Devicedetails
   */
  public selectedDevice: ItemDetail;

  /**
   * Holds main image URL
   */
  public mainImageUrl: string;

  /**
   * Holds static content data
   */
  @Input() public pdpStaticContent: ConfigData;

  /**
   * Holds the dummy image url
   */
  public dummyImage: string;
  /**
   * Holds the external domain URL to load images
   */
  public extTmoImagesUrl: string;

  /**
   * Contains array of DeviceSimInfo for current device
   */
  public deviceSimInfo: DeviceSimInfo[];

  /**
   * boolean to keep check if user is in upgrade flow
   */
  @Input() public isUpgrade: boolean;

  public deviceName: string;

  constructor(
    private objectService: ObjectService,
    private productDetailsService: ProductDetailsService,
    private commonUtilService: CommonUtilService
  ) {
    this.extTmoImagesUrl = SETTINGS.EXT_IMAGE_URL;
  }

  /**
   * Loads the initial configuration of Product Selector Page
   * @returns void
   */
  public ngOnInit(): void {
    this.deviceName = this.deviceDetails.familyName
      ? this.deviceDetails.familyName.substring(this.deviceDetails.familyName.indexOf(' ') + 1)
      : '';
    this.getDummyImageUrl();
  }

  /**
   * Function used to get no image found image
   */
  public getDummyImageUrl(): void {
    this.dummyImage = this.commonUtilService.getImageUrl(null);
  }
}
